export default __webpack_public_path__ + "8bac45b0b2501a255d438c5bc4d7a6dc.png";